export default __webpack_public_path__ + "d573f01c73af654335f75959189bf815.png";